import { ActionType, createAction } from 'typesafe-actions';
import { IAppConfig, IAppInitConfig, IUserInfo } from 'types';

export const appActions = {
    appSetConfig: createAction('APP_SET_CONFIG')<IAppConfig>(),
    appSetInitConfig: createAction('APP_SET_INIT_CONFIG')<IAppInitConfig>(),
    appSetFiltersWindowVisible: createAction('APP_SET_FILTERS_WINDOW_VISIBLE')<boolean>(),
    appSetAuthToken: createAction('APP_SET_AUTH_TOKEN')<string>(),
    refuseMobileApp: createAction('APP_REFUSE_MOBILE_APP')(),
    setUserInfo: createAction('APP_SET_USER_INFO')<IUserInfo | null>()
};

export type TAppActions = ActionType<typeof appActions>;
